import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, TextField, FormControlLabel, Checkbox, RadioGroup, Radio, Button, ToggleButtonGroup, ToggleButton } from '@mui/material';
import useFetch from '../../hooks/useFetch';
import { parseMoney } from './money';

export default function BillForm({ mode, date, accounts, setAuth, onSaved, onCancel }) {
  const { t } = useTranslation();
  const { fetchResource, isPending } = useFetch({ setAuth });
  const [payee, setPayee] = useState('');
  const [amount, setAmount] = useState('');
  const [isEstimate, setIsEstimate] = useState(false);
  const [cadence, setCadence] = useState('monthly');
  const [intervalWeeks, setIntervalWeeks] = useState('2');
  const [accountId, setAccountId] = useState(null);
  const [billDate, setBillDate] = useState(date);
  const cents = parseMoney(amount);
  const operating = accounts.filter(a => a.role === 'operating');
  const ready = payee.trim() && cents && accountId;

  const save = async () => {
    const body = { payee: payee.trim(), amountCents: cents, isEstimate, bankAccountId: accountId };
    if (mode === 'once') Object.assign(body, { cadence: 'once', dueDate: billDate });
    else if (cadence === 'monthly') Object.assign(body, { cadence: 'monthly', dayOfMonth: Number(billDate.slice(8, 10)) });
    else Object.assign(body, { cadence: 'weeks', intervalWeeks: Number(intervalWeeks), anchorDate: billDate });
    const r = await fetchResource({ resource: 'calendar/bills', body, loadingKey: 'bill' });
    if (!r.error) onSaved();
  };

  return (
    <Stack spacing={2}>
      <TextField label={t(mode === 'once' ? 'calendar.bill.what' : 'calendar.bill.payee')} value={payee} onChange={e => setPayee(e.target.value)} />
      <TextField label={t('calendar.bill.amount')} value={amount} onChange={e => setAmount(e.target.value)} inputProps={{ inputMode: 'decimal' }} error={Boolean(amount) && cents == null} />
      <TextField label={t(mode === 'once' ? 'calendar.bill.date' : 'calendar.bill.day')} type='date' value={billDate} onChange={e => setBillDate(e.target.value)} InputLabelProps={{ shrink: true }} />
      {mode === 'recurring' && (
        <>
          <FormControlLabel control={<Checkbox checked={isEstimate} onChange={e => setIsEstimate(e.target.checked)} />} label={t('calendar.bill.estimate')} />
          <ToggleButtonGroup exclusive size='small' value={cadence} onChange={(e, v) => v && setCadence(v)}>
            <ToggleButton value='monthly'>{t('calendar.checks.monthly')}</ToggleButton>
            <ToggleButton value='weeks'>{t('calendar.bill.everyWeeks')}</ToggleButton>
          </ToggleButtonGroup>
          {cadence === 'weeks' && <TextField label={t('calendar.bill.every')} value={intervalWeeks} onChange={e => setIntervalWeeks(e.target.value.replace(/\D/g, ''))} inputProps={{ inputMode: 'numeric' }} />}
        </>
      )}
      <RadioGroup value={accountId ?? ''} onChange={e => setAccountId(Number(e.target.value))}>
        {operating.map(a => <FormControlLabel key={a.id} value={a.id} control={<Radio />} label={a.nickname} />)}
      </RadioGroup>
      <Stack direction='row' spacing={1}>
        <Button onClick={onCancel}>{t('common.cancel')}</Button>
        <Button variant='contained' disabled={!ready || isPending('bill')} onClick={save}>{t('calendar.review.save')}</Button>
      </Stack>
    </Stack>
  );
}
